import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { RecaptchaModule } from 'ng-recaptcha';


//Cookies
import { CookieLawModule } from 'angular2-cookie-law';

// Calendar
import { NgbModalModule, NgbDateParserFormatter, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { FlatpickrModule } from 'angularx-flatpickr';
import { CalendarModule } from 'primeng/calendar';

// Interceptor http
import { AllHttpRequestsInterceptor } from "@interceptors/allhttprequests.interceptor";

// Angular animations
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// Components from ng-bootstrap.github.io
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

// Translate
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// Routes
import { AppRoutingModule } from '@app/app.routes';

// Services
import {
  UserService,
  AuthService,
  ResourceService,
  OpentokService
} from "@services/index.service";

//Guards
import { AuthGuardService } from '@services/auth-guard/auth-guard.service';

// Pages
import {
  BookappointmentsComponent,
  RegisterComponent,
  ConfirmmailComponent,
  FaqComponent,
  SecondopinionComponent
} from "@pages/index.pages";

// Components
import {
  AppComponent,
  NavbarComponent,
  FooterComponent,
  LangSelectorComponent,
} from "@components/index.components";

import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '@environments/environment';
import { SelectComponent } from '@components/select/select.component';
import { ComponentsModule } from '@components/components.module';
import { MomentDateFormatter } from '@providers/momentDateFormatter.provider';

import { CustomDatepickerI18n, I18n } from '@services/i18n/datepicker-i18n';
import { PortalConfigurationService } from './services/portal-configuration/portal-configuration.service';
import { DatabaseResourcesService } from './services/database-resources/database-resources.service';
import { ConfirmationModalComponent } from '@components/modals/confirmation-modal/confirmation-modal.component';
import { MessageModalComponent } from '@components/modals/message-modal/message-modal.component';
import { AdminModule } from './pages/admin-pages/admin.module';


export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}
@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    LangSelectorComponent,
    FooterComponent,
    BookappointmentsComponent,
    RegisterComponent,
    ConfirmmailComponent,
    SecondopinionComponent,
    FaqComponent,
    SelectComponent,
    MessageModalComponent
  ],
  imports: [
    ComponentsModule,
    AdminModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    RecaptchaModule,
    NgbModalModule,
    ReactiveFormsModule,
    CookieLawModule,
    HttpClientModule,
    BsDatepickerModule.forRoot(),
    NgbModule,
    FlatpickrModule.forRoot(),
    CalendarModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    ServiceWorkerModule.register('servicesWorkers.js', { enabled: environment.serviceWorker && environment.production })
  ],
  exports: [TranslateModule],
  providers: [
    UserService,
    AuthService,
    ResourceService,
    PortalConfigurationService,
    DatabaseResourcesService,
    OpentokService,
    { provide: NgbDateParserFormatter, useClass: MomentDateFormatter },
    AuthGuardService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AllHttpRequestsInterceptor,
      multi: true
    },
    I18n,
    { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
